import axios from "axios";
import React, { useEffect, useState } from "react";
import { Auth_URL } from "../../redux/Url";
import { getAWSDashboard } from "../../redux/DashBoard/action";
import { connect } from "react-redux";

const QuickSightEmbed = (props) => {
  const [embedUrl, setEmbedUrl] = useState("");

  const fetchAWSDashboardUrl = (tabStatus) => {
    props
      .getDashboardData({
        access_token: props?.access_token,
      })
      .then((res) => {
        if (res?.status == 200) {
          if (res?.data?.embedUrl) {
            setEmbedUrl(`${res?.data?.embedUrl}#p.PARTNERID=${props?.firmId}`);
          }
        }
      });
  };
  useEffect(() => {
    fetchAWSDashboardUrl();
  }, []);
  return (
    <div>
      <iframe
        src={embedUrl}
        width="100%"
        height="1000"
        id="quicksight-embed"
        display="initial"
        position="relative"
      />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDashboardData: (data) => dispatch(getAWSDashboard(data)),
  };
};
const mapStateToProps = (state) => {
  return {
    access_token: state.auth.idToken,
    firmId:
      state.auth?.checkLogin?.partnerFirmId ||
      state?.auth?.loginCredentials?.data?.partnerFirmDetails?.partnerFirmId,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(QuickSightEmbed);
